import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const removeAdditionalParent = async (subCategoryId: string, parentCategoryId: string) => {
  const [response, bodyOrError] = await Api.post(`sub-categories/${subCategoryId}/remove-parent`, {
    parentCategoryId,
  });
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useRemoveAdditionalParent = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'removeAdditionalParent',
    (data: { subCategoryId: string; parentCategoryId: string }) => {
      return removeAdditionalParent(data.subCategoryId, data.parentCategoryId);
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['getSubCategory', variables.subCategoryId]);
      },
    },
  );
};
